import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float, ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { Names } from '@ils/static/names.js';
import { ExamDay } from '../../../src/db/examdays.js';
import { ILSUser } from '../../../src/db/ils-user.js';
import { Order } from '../../../src/db/order.js';

@Entity()
export class UserExportLine extends AdornisEntity {
  static override _class = Names.UserExportLine._class;
  static _collectionName = Names.UserExportLine._collectionName;

  static override resolveID(entity: UserExportLine): string {
    return entity._id;
  }

  @Field(type => ID) _id!: string;
  @Field(type => ILSUser) user!: ILSUser;
  @Field(type => Order) order: Maybe<Order>;
  @Field(type => ExamDay) examday: Maybe<ExamDay>;
  @Field(type => Boolean) passedExamDay: Maybe<boolean>;
  @Field(type => Float) userScore: Maybe<number>;
  @Field(type => Boolean) isRated: Maybe<boolean>;
}
